import { EnvironmentService } from '../service/service.module';
import { Injectable } from '@angular/core';

import { UserManager, UserManagerSettings, User } from 'oidc-client';

@Injectable()
export class TurtleBeachAuthService {
  environment = EnvironmentService.environment;
  private manager: UserManager = new UserManager(getClientSettings(this.environment));
  private user: User | any = null;

  constructor() {
    this.manager.getUser().then(user => {
      this.user = user;
    });
  }

  isLoggedIn(): boolean {
    return this.user != null && !this.user.expired;
  }

  getClaims(): any {
    return this.user;
  }

  getAuthorizationHeaderValue(): string {
    return `${this.user.access_token}`;
  }

  startAuthentication(): Promise<void> {
    return this.manager.signinRedirect();
  }

  completeAuthentication(): Promise<void> {
    return this.manager.signinRedirectCallback().then(user => {
      this.user = user;
    });
  }

  async logout() {
    await this.manager.removeUser();
    this.manager.signoutRedirectCallback(this.environment.turtleBeachLogin.post_logout_redirect_uri);
  }
}

export function getClientSettings(environment: any): UserManagerSettings {
  return {
    // authority: 'https://turtlebeach.onelogin.com/oidc/2',                                //TB
    // client_id: '54391d40-50df-013d-520f-0e7be893efd965395',                              //TB
    // redirect_uri: 'https://alpha-dev-portal.algoplus.com/auth-callback',                 //TB
    // silent_redirect_uri: 'https://alpha-dev-portal.algoplus.com/silent-refresh.html',    //TB
    // post_logout_redirect_uri: 'https://alpha-dev-portal.algoplus.com/',                  //TB

    // authority: 'https://algodev.onelogin.com/oidc/2',                                       //Algo
    // client_id: 'fb78b0c0-50c0-013d-7aac-6a920dd4614b240669',                                 //Algo
    // redirect_uri: 'https://alpha-dev-portal.algoplus.com/auth-callback',                    //Algo
    // silent_redirect_uri: 'https://alpha-dev-portal.algoplus.com/silent-refresh.html',       //Algo
    // post_logout_redirect_uri: 'https://alpha-dev-portal.algoplus.com/',                     //Algo

    authority: environment.turtleBeachLogin.authority,                                         
    client_id: environment.turtleBeachLogin.client_id,                                      
    redirect_uri: environment.turtleBeachLogin.redirect_uri,                                       
    post_logout_redirect_uri: environment.turtleBeachLogin.post_logout_redirect_uri,                                           
    silent_redirect_uri: environment.turtleBeachLogin.silent_redirect_uri,                            
    response_type: environment.turtleBeachLogin.response_type,
    scope: environment.turtleBeachLogin.scope,
    filterProtocolClaims: environment.turtleBeachLogin.filterProtocolClaims,
    loadUserInfo: environment.turtleBeachLogin.loadUserInfo,
    automaticSilentRenew: environment.turtleBeachLogin.automaticSilentRenew
  }
}
